import { css, keyframes } from '@emotion/react';
import { useDimensions } from '../../../hooks';
import { Animation, Colors, Shadows, Typography } from '../../../theme';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const distance = '5px';
const tooltipOpenAnimation = keyframes({
    '0%': {
        opacity: 0,
    },
    '100%': {
        opacity: 1,
    },
});
export const positionStyles = {
    northwest: css `
    bottom: calc(100% + ${distance});
    left: 0;
  `,
    north: css `
    bottom: calc(100% + ${distance});
    left: 50%;
    transform: translateX(-50%);
  `,
    northeast: css `
    bottom: calc(100% + ${distance});
    right: 0;
  `,
    east: css `
    left: calc(100% + ${distance});
    top: 50%;
    transform: translateY(-50%);
  `,
    southeast: css `
    top: calc(100% + ${distance});
    right: 0;
  `,
    south: css `
    top: calc(100% + ${distance});
    left: 50%;
    transform: translateX(-50%);
  `,
    southwest: css `
    top: calc(100% + ${distance});
    left: 0;
  `,
    west: css `
    right: calc(100% + ${distance});
    top: 50%;
    transform: translateY(-50%);
  `,
};
const singleLineHeightPlusPadding = 28;
const defaultPosition = 'south';
const Styles = labelStyles('Tooltip', {
    root: ({ position = defaultPosition, allowMultiline, isInteractive }, isMultiline) => [
        css `
      display: block;
      color: ${Colors.neutral100};
      text-align: center;
      border-radius: 100px;
      position: relative;
      z-index: 2;
      box-shadow: ${Shadows.elevation30};
      background-color: ${Colors.neutral800};
      width: max-content;
      max-width: 300px;
      animation: ${Animation.transitionDuration}
        ${Animation.transitionTimingFunction} ${tooltipOpenAnimation};
      ${Typography.paragraph3Semibold};
      padding: 2px 11px;
      */

      // Increase mouse area so tooltip doesn't disappear when
      // mousing over a gap between its toggle and the tooltip itself.
      &::before {
        content: '';
        position: absolute;
        top: -${distance};
        right: -${distance};
        bottom: -${distance};
        left: -${distance};
        z-index: -1;
      }
    `,
        position &&
            css `
        label: -${position};
        position: absolute;
        ${positionStyles[position]};
      `,
        isMultiline &&
            css `
        label: -multiline;
        border-radius: 10px;
        padding: 16px 14px;
        text-align: left;
      `,
        !allowMultiline &&
            css `
        label: -single-line;
        height: ${singleLineHeightPlusPadding}px;
        padding: 2px 11px;
      `,
        !isInteractive &&
            css `
        label: -non-interactive;
        pointer-events: none;
      `,
    ],
    content: (props) => [
        css `
      display: block;
    `,
        !props.allowMultiline &&
            css `
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      `,
    ],
});
export const Tooltip = (props) => {
    const [ref, { height }] = useDimensions();
    const isMultiline = height > singleLineHeightPlusPadding;
    return (isolateComponent("span", { "aria-hidden": props.ariaHidden, css: Styles.root(props, isMultiline), "data-testid": `tooltip-${props.position}`, id: props.id, ref: ref, role: "tooltip" },
        isolateComponent("span", { css: Styles.content(props) }, props.children)));
};
Tooltip.defaultProps = {
    allowMultiline: false,
    position: defaultPosition,
};
//# sourceMappingURL=Tooltip.js.map
// @zapier/design-system@5.21.5 (00611e727)
